<app-loader *ngIf="isLoading"></app-loader>
<div class="page-container">
	<!-- <pre>{{ payload | json }}</pre> -->
	<div class="top-buttons d-flex justify-content-between align-items-center">
		<button class="btn-back" (click)="onBack()"><i class="bx bx-arrow-back" ngbtooltip="Back"></i></button>
		<button class="btn-exit" (click)="onExit()"><i class="ri-close-fill" ngbtooltip="Exit"></i></button>
	</div>
	<h2 class="form-title">📞 Please double-click one dispo from below</h2>
	<!-- <div *ngIf="selectedDispo" class="alert alert-info mt-3">
		Selected Disposition: <strong>{{ selectedDispo }}</strong>
	</div> -->
	<form [formGroup]="dispoForm" (ngSubmit)="onSubmit()" class="form-box">
		<div class="dispo-grid">
			<div class="card">
				<h3 class="card-title black">Bad Phone Number/Record ©</h3>
				<div class="options">
					<label *ngFor="let option of badPhoneOptions" class="option" [class.selected]="selectedDispo === option.value" (dblclick)="selectBadPhoneDispo(option.value)">
						<div class="option-label">{{ option.label }}</div>
						<div class="option-desc">{{ option.description }}</div>
					</label>
				</div>
			</div>

			<div class="card">
				<h3 class="card-title blue">No Answer / Voicemail 😐</h3>
				<div class="options">
					<label *ngFor="let option of noAnswerOptions" class="option" [class.selected]="selectedDispo === option.value" (dblclick)="selectNoAnswerDispo(option.value)">
						<div class="option-label">{{ option.label }}</div>
						<div class="option-desc">{{ option.description }}</div>
					</label>
				</div>
			</div>
			<div class="card">
				<h3 class="card-title yellow">Call Back Another Day 😟</h3>
				<div class="options">
					<label *ngFor="let option of callBackOptions" class="option" [class.selected]="selectedDispo === option.value" (dblclick)="selectCallBackDispo(option.value)">
						<div class="option-label">{{ option.label }}</div>
						<div class="option-desc">{{ option.description }}</div>
					</label>
				</div>
			</div>
			<div class="card">
				<h3 class="card-title green">Lead / Opt-In 🤑</h3>
				<div class="options">
					<label *ngFor="let option of leadOptions" class="option" [class.selected]="selectedDispo === option.value" (dblclick)="selectLeadDispo(option.value)">
						<div class="option-label">{{ option.label }}</div>
						<div class="option-desc">{{ option.description }}</div>
					</label>
				</div>
			</div>
		</div>
	</form>
</div>
<ng-template #modalCallback let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Set Callback</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-4">
				<button (click)="setCallBackDate('tomorrow')" class="btn btn-primary btn-lg" [ngClass]="{ 'btn-secondary': !callBackButtons.tomorrow, 'btn-primary': callBackButtons.tomorrow }" style="width: 100%; margin-bottom: 20px">Tomorrow</button>
				<br />
				<button (click)="setCallBackDate('next_week')" class="btn btn-primary btn-lg" [ngClass]="{ 'btn-secondary': !callBackButtons.next_week, 'btn-primary': callBackButtons.next_week }" style="width: 100%; margin-bottom: 20px">Next Week</button>
				<br />
				<button (click)="setCallBackDate('next_month')" class="btn btn-primary btn-lg" [ngClass]="{ 'btn-secondary': !callBackButtons.next_month, 'btn-primary': callBackButtons.next_month }" style="width: 100%">Next Month</button>
			</div>
			<div class="col-8">
				<div class="row">
					<div class="col-12" align="center">
						<h4 style="margin: 0px; margin-top: 20px">Call back on:</h4>
						<h2 style="margin: 0px">{{ formatCallBackDate() }}</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<label for="">Quantity</label>
						<input type="number" (input)="setDateChange()" [(ngModel)]="callBackQuantity" class="form-control" />
					</div>
					<div class="col-6">
						<label for="">Type</label>
						<select class="form-control" [(ngModel)]="callBackTimeType" (change)="setDateChange()">
							<option value="day">Day(s)</option>
							<option value="week">Week(s)</option>
							<option value="month">Month(s)</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button [disabled]="!prospect" type="button" class="btn btn-primary" (click)="dispoHotCallback(); modal.dismiss()">Save</button>
	</div>
</ng-template>

<ng-template #modalFYI let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title" style="margin-top: 0px; font-size: 18px; font-weight: 500">This content will be send via email to: {{ email1 }}</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-12" *ngIf="!sendingEmail">
				<div align="center">
					<!-- <img src="assets\img\logo_new.png" height="60px"> -->
				</div>
				<p style="font-weight: 800; font-size: 23px">You have a new prospect interested in your products.</p>
				<p>Here is all the information you need to contact them:</p>
				<br />
				<p>
					<strong style="font-weight: 800">Title: </strong>{{ prospect.title }}<br />
					<strong style="font-weight: 800">Name: </strong>{{ prospect.first_name }} {{ prospect.last_name }} <br />
					<strong style="font-weight: 800">Primary Phone: </strong>{{ prospect.primary_phone }} <br />
					<strong style="font-weight: 800">Alternative Contact: </strong>{{ prospect.alt_contact }} <br />
					<strong style="font-weight: 800">Company Name: </strong>{{ prospect.company_name }} <br />
					<strong style="font-weight: 800">Email: </strong>{{ prospect.primary_email }} <br />
					<strong style="font-weight: 800">Address: </strong>{{ prospect.address_1 }} <br />
					<strong style="font-weight: 800">State: </strong>{{ prospect.state }} <br />
					<strong style="font-weight: 800">Zip Code: </strong>{{ prospect.zip }} <br />
					<strong style="font-weight: 800">Provider 1: </strong>{{ prospect.provider_1 }} <br />
					<strong style="font-weight: 800">Provider 2: </strong>{{ prospect.provider_2 }} <br />
					<strong style="font-weight: 800">Employee Size: </strong>{{ prospect.employee_size }} <br />
					<strong style="font-weight: 800">Notes: </strong>{{ prospect.notes }} <br />
				</p>
				<br />
				<p>If you have any questions you can contact us through email, or via chat in your portal.</p>
			</div>
			<div class="col-12" *ngIf="sendingEmail">
				<app-loading></app-loading>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" [disabled]="sendingEmail" class="btn btn-primary" (click)="modalSrv.dismissAll()">Cancel</button>
		<button type="button" [disabled]="sendingEmail" class="btn btn-primary" (click)="dispoFYI()">Send</button>
	</div>
</ng-template>

<ng-template #modalSINFO let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title" style="margin-top: 0px; font-size: 18px; font-weight: 500">This content will be send via email to: {{ prospect.primary_email }}</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-12" *ngIf="!sendingEmail">
				<p style="font-weight: 800; font-size: 23px">Info related from a recent call</p>
				<p>
					<strong style="font-weight: 800">{{ campaign.name }}</strong>
				</p>
				<div class="email-template" [innerHTML]="campaign.email_template"></div>
			</div>
			<div class="col-12" *ngIf="sendingEmail">
				<app-loading></app-loading>
			</div>
		</div>
		<div *ngIf="isLoading" class="loader-overlay">
  <div class="spinner"></div>
</div>

	</div>
	<div class="modal-footer">
		<button type="button" [disabled]="sendingEmail" class="btn btn-primary" (click)="modalSrv.dismissAll()">Cancel</button>
		<button type="button" [disabled]="sendingEmail" class="btn btn-primary" (click)="dispoSINfO()">Send</button>
	</div>
</ng-template>

<ng-template #modalCallback let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Set Callback</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-4">
				<button (click)="setCallBackDate('tomorrow')" class="btn btn-primary btn-lg" [ngClass]="{ 'btn-secondary': !callBackButtons.tomorrow, 'btn-primary': callBackButtons.tomorrow }" style="width: 100%; margin-bottom: 20px">Tomorrow</button>
				<br />
				<button (click)="setCallBackDate('next_week')" class="btn btn-primary btn-lg" [ngClass]="{ 'btn-secondary': !callBackButtons.next_week, 'btn-primary': callBackButtons.next_week }" style="width: 100%; margin-bottom: 20px">Next Week</button>
				<br />
				<button (click)="setCallBackDate('next_month')" class="btn btn-primary btn-lg" [ngClass]="{ 'btn-secondary': !callBackButtons.next_month, 'btn-primary': callBackButtons.next_month }" style="width: 100%">Next Month</button>
			</div>
			<div class="col-8">
				<div class="row">
					<div class="col-12" align="center">
						<h4 style="margin: 0px; margin-top: 20px">Call back on:</h4>
						<h2 style="margin: 0px">{{ formatCallBackDate() }}</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<label for="">Quantity</label>
						<input type="number" (input)="setDateChange()" [(ngModel)]="callBackQuantity" class="form-control" />
					</div>
					<div class="col-6">
						<label for="">Type</label>
						<select class="form-control" [(ngModel)]="callBackTimeType" (change)="setDateChange()">
							<option value="day">Day(s)</option>
							<option value="week">Week(s)</option>
							<option value="month">Month(s)</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button [disabled]="!prospect" type="button" class="btn btn-primary" (click)="dispoHotCallback(); modal.dismiss()">Save</button>
	</div>
</ng-template>

<ng-template #modalFYI let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title" style="margin-top: 0px; font-size: 18px; font-weight: 500">This content will be send via email to: {{ email1 }}</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-12" *ngIf="!sendingEmail">
				<div align="center">
					<!-- <img src="assets\img\logo_new.png" height="60px"> -->
				</div>
				<p style="font-weight: 800; font-size: 23px">You have a new prospect interested in your products.</p>
				<p>Here is all the information you need to contact them:</p>
				<br />
				<p>
					<strong style="font-weight: 800">Title: </strong>{{ prospect.title }}<br />
					<strong style="font-weight: 800">Name: </strong>{{ prospect.first_name }} {{ prospect.last_name }} <br />
					<strong style="font-weight: 800">Primary Phone: </strong>{{ prospect.primary_phone }} <br />
					<strong style="font-weight: 800">Alternative Contact: </strong>{{ prospect.alt_contact }} <br />
					<strong style="font-weight: 800">Company Name: </strong>{{ prospect.company_name }} <br />
					<strong style="font-weight: 800">Email: </strong>{{ prospect.primary_email }} <br />
					<strong style="font-weight: 800">Address: </strong>{{ prospect.address_1 }} <br />
					<strong style="font-weight: 800">State: </strong>{{ prospect.state }} <br />
					<strong style="font-weight: 800">Zip Code: </strong>{{ prospect.zip }} <br />
					<strong style="font-weight: 800">Provider 1: </strong>{{ prospect.provider_1 }} <br />
					<strong style="font-weight: 800">Provider 2: </strong>{{ prospect.provider_2 }} <br />
					<strong style="font-weight: 800">Employee Size: </strong>{{ prospect.employee_size }} <br />
					<strong style="font-weight: 800">Notes: </strong>{{ prospect.notes }} <br />
				</p>
				<br />
				<p>If you have any questions you can contact us through email, or via chat in your portal.</p>
			</div>
			<div class="col-12" *ngIf="sendingEmail">
				<app-loading></app-loading>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" [disabled]="sendingEmail" class="btn btn-primary" (click)="modalSrv.dismissAll()">Cancel</button>
		<button type="button" [disabled]="sendingEmail" class="btn btn-primary" (click)="dispoFYI()">Send</button>
	</div>
</ng-template>

<ng-template #modalSINFO let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title" style="margin-top: 0px; font-size: 18px; font-weight: 500">This content will be send via email to: {{ prospect.primary_email }}</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-12" *ngIf="!sendingEmail">
				<p style="font-weight: 800; font-size: 23px">Info related from a recent call</p>
				<p>
					<strong style="font-weight: 800">{{ campaign.name }}</strong>
				</p>
				<div class="email-template" [innerHTML]="campaign.email_template"></div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" [disabled]="sendingEmail" class="btn btn-primary" (click)="modalSrv.dismissAll()">Cancel</button>
		<button type="button" [disabled]="sendingEmail" class="btn btn-primary" (click)="dispoSINfO()">Send</button>
	</div>
</ng-template>
